module.exports = __webpack_public_path__ + "img/01-illu-sweets0226.2f6634bb.png";